import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _get from 'lodash/get';
import { UserDetailsContext } from 'context/userDetails';

const usePaymentStatus = () => {
	const history = useHistory();
	const queryParams = _get(history, ['location', 'search']);
	const { userSearchDetails } = useContext(UserDetailsContext);

	return { queryParams, userSearchDetails };
};

export default usePaymentStatus;
